<template>
  <div v-if="!globalIsLoading">
    <mobile-header />
    <div class="container mb-5">
      <div class="row desktop-header d-none d-md-flex">
        <div class="row">
          <div class="flex-grow-1">
            <router-link to="dashboard">
              <img class="header-logo" src="@/assets/logos/av-rebrand-logo.svg" alt="AutoVerify home" width="240" />
            </router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5 col-lg-6">
          <img
            v-if="$route.name === 'register'"
            class="auth-image"
            src="@/assets/computer-illustration-register.svg"
            alt=""
            role="presentation"
          />
          <img
            v-else-if="$route.name !== 'error'"
            class="auth-image"
            src="@/assets/car-and-charts.svg"
            alt=""
            role="presentation"
          />
          <img v-else class="auth-image" src="@/assets/construction-illustration.svg" alt="" role="presentation" />
        </div>
        <div class="col-12 col-md-7 col-lg-5 pt-lg-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileHeader from '@/app/global/components/MobileHeader.vue';

export default {
  name: 'NonAuthenticated',
  components: {
    MobileHeader,
  },
  computed: {
    ...mapState({
      globalIsLoading: state => state.globalIsLoading,
    }),
  },
  created() {
    this.$store.commit('SET_GLOBAL_LOADING', false);
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .container {
    max-width: 1440px;
  }
}
.desktop-header {
  padding-top: 25px;
  padding-bottom: 30px;
  @media screen and (min-width: 768px) {
    padding-top: 25px;
  }
  .header-title {
    font-size: 16px;
  }
  .separator {
    margin: 0 16px;
    vertical-align: middle;
    display: inline-block;
    height: 20px;
    width: 1px;
    background-color: #dbdbdb;
  }
}
.auth-image {
  display: block;
  height: 202px;
  max-width: 245px;
  width: 100%;
  margin: 33px auto 0;
  @media screen and (min-width: 768px) {
    height: 378px;
    max-width: 458px;
    margin: 50px auto 30px;
  }
}
</style>
